<template>
  <session class="page-home" :class="{ active: position != null, 'loadin-ani': loadinAni }">
    <div class="pagecover" v-if="!ctrlFlag" />
    <div class="bg" />
    <div class="home-mainblock" :class="{ active: position == 1, en: getLocalLangCode() == 'en', jp: getLocalLangCode() == 'jp', kr: getLocalLangCode() == 'kr' }" @mouseleave="setPosition(null)" @click="toTagetPage('aboutus')">
      <div class="title" @mouseenter.stop="setPosition(1)"><span class="t4" :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('home_aboutUs')}}</span></div>
      <div class="content">
        <span v-html="Utils.presetHtmlText(LOCAL('home_aboutUs_desc'))" />
        <div class="content-entrances">
          <div class="item"><Icon name="checkmore" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('checkmore')}}</span></div>
        </div>
      </div>
    </div>
    <div class="home-mainblock" :class="{ active: position == 2, en: getLocalLangCode() == 'en', jp: getLocalLangCode() == 'jp', kr: getLocalLangCode() == 'kr', large:  getLocalLangCode() == 'en' }" @mouseleave="setPosition(null)">
      <div class="title" @mouseenter.stop="setPosition(2)"><span class="t5" :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('home_productService')}}</span></div>
      <div class="content">
        <span>{{LOCAL('home_productService_desc')}}</span>
        <div class="content-entrances">
          <div class="item" @click="toTagetPage('productservice')"><Icon name="checkmore" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('checkmore')}}</span></div>
          <div class="item gift" @click="Utils.loginDialogToggle(true,'person')"><Icon name="gift" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('home_policyExchange')}}</span></div>
        </div>
      </div>
    </div>
    <div class="home-mainblock" :class="{ active: position == 3, en: getLocalLangCode() == 'en', jp: getLocalLangCode() == 'jp', kr: getLocalLangCode() == 'kr' }" @mouseleave="setPosition(null)" @click="toTagetPage('claims')">
      <div class="title" @mouseenter.stop="setPosition(3)"><span class="t2" :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('home_claims')}}</span></div>
      <div class="content">
        <span>{{LOCAL('home_claims_desc')}}</span>
        <div class="content-entrances">
          <div class="item"><Icon name="checkmore" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('checkmore')}}</span></div>
        </div>
      </div>
    </div>
    <div class="home-logoblock">
      <img class="logo-img" src="@/assets/images/logo-en.svg" v-if="!getLocalLangCode() || getLocalLangCode() == 'en'" />
      <img class="logo-img" src="@/assets/images/logo.svg" v-if="getLocalLangCode() == 'zh'" />
      <img class="logo-img" src="@/assets/images/logo-jp.svg" v-if="getLocalLangCode() == 'jp'" />
      <img class="logo-img" src="@/assets/images/logo-kr.svg" v-if="getLocalLangCode() == 'kr'" />

      <div class="slogan">
        <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('slogan')[0]}}</span>
        <span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('slogan')[1]}}</span>
      </div>
      <div class="btns">
        <!-- <div class="btnitem grey"><Icon name="checkmore grey" size="48" /><span>{{LOCAL('home_getPolicy')}}</span></div> -->
        <div class="btnitem" @click="Utils.loginDialogToggle(true)"><Icon name="checkmore" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('login')}}</span></div>
      </div>
    </div>
    <div class="home-logoblock-cover">
      <img class="logo-img" src="@/assets/images/logo.svg" />
      <div class="slogan" />
    </div>
  </session>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import * as Utils from '@/assets/utils';
  import { LOCAL, getLocalLangCode } from '@/assets/lang/index';
  import Icon from '@/components/icon/index.vue';
  import router from '@/router';

  const loadinAni = ref(false);
  const ctrlFlag = ref(false);
  onMounted(() => {
    setTimeout(() => {
      loadinAni.value = true;
    }, 800);

    setTimeout(() => {
      ctrlFlag.value = true;
    }, 2500);
  });

  const position = ref(null); // 1-关于我们；2-产品服务；3-索偿
  const setPosition = p => {
    position.value = p;
  }

  const toTagetPage = path => {
    router.push(path || '/');
  }

  const showExchangeFlow = ref(true);
  const toggleExchangeFlowHandle = (flag) => {
    console.log('flag', flag)
    showExchangeFlow.value = flag
  }
</script>

<style scoped lang="less">
  @import "index.less";
</style>
